function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
/* eslint-disable no-param-reassign */
import Cookies from 'js-cookie';
import { getDomain } from '.';
var hostDomain = getDomain();
var defaultCookieOption = {
  path: '/',
  domain: hostDomain,
  expires: 7
};
// 若当前对象不是top对象 ==> 在iframe中
if (window.self !== window.top) {
  // 设置 sameSite secure 允许跨域写入cookie
  defaultCookieOption.sameSite = 'None';
  defaultCookieOption.secure = true;
}
export function setCookie(name, value) {
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultCookieOption;
  if (!value) {
    value = '';
  }
  if (_typeof(value) === 'object' || typeof value === 'function') {
    value = JSON.stringify(value);
  }
  Cookies.set(name, value, option);
}
export function getCookie(key) {
  var value = Cookies.get(key);
  if (!value) {
    return null;
  }
  try {
    var obj = JSON.parse(value);
    return obj;
  } catch (error) {
    return value;
  }
}
export function delCookie(key) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    path: '/',
    domain: hostDomain
  };
  return Cookies.remove(key, option);
}